export default __webpack_public_path__ + "images/LJ.499d0d5.png";